import http from './httpServices';

const ZapierIntegrationService = {
  getStatus: () => http.get('/integrations/zapier/status'),
  revokeAll: () => http.delete('/integrations/zapier/connections'),
};

export default ZapierIntegrationService;
